export default "__VITE_ASSET__oKfr6X4h__"